import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ListarMedicoComponent } from "./listar-medico/listar-medico.component";
import { EditarMedicoComponent } from "./editar-medico/editar-medico.component";
import { MovimientosMedicoComponent } from "./movimientos-medico/movimientos-medico.component";

const routes: Routes = [
  {
    path: "medico",
    pathMatch: "full",
    component: ListarMedicoComponent,
  },
  {
    path: "medico/editar/:id",
    pathMatch: "full",
    component: EditarMedicoComponent,
  },
  {
    path: "medico/movimientos/:id",
    pathMatch: "full",
    component: MovimientosMedicoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MedicoRoutingModule {}
